import { FC } from "react";
import { TabbedDashLayout } from "../../layouts/TabbedDashLayout";
import { ErrorsView, GlobalDevices, GlobalUsers, GroundTruthing, Jobs, ManageFirmware, OrganizationAdmin, ServerCache } from ".";
import { ChirpLibrary } from "./ChirpLibrary";
import { AuditLogsView } from "./AuditLogs";
import { TrackerLibrary } from "./TrackerLibrary";
import { PhotoLibrary } from "./PhotoLibrary";
import { Button, Healths, useAuth, useDialog } from "@app/shared";
import { Input, InputRow } from "../../shared";

export const Settings: FC = (props) => {
    const dialog = useDialog<{ message: string, instructions: string }>();
    const { isInMaintenanceMode, refreshMaintenanceMode } = useAuth();


    const handleMMClick = () => {
        if (isInMaintenanceMode) {
            const model = { message: '', instructions: `Are you sure you want to end maintenance mode? The api will begin handling device requests immediately` };
            dialog.show("End Maintenance Mode", 'Ok', model, async () => {
                await Healths.exitMaintenanceMode(model.message);
                await refreshMaintenanceMode();
            });
        } else {
            const model = { message: '', instructions: `Are you sure you want to enter maintenance mode? The api will end handling new device requests immediately and fail existing requests after 1 minute` };
            dialog.show("Enter Maintenance Mode", "Ok", model, async () => {
                await Healths.enterMaintenanceMode(model.message);
                await refreshMaintenanceMode();
            });
        }
    }
    return (
        <>
            <TabbedDashLayout
                centerChildren="Site Admin"
                rightChildren={<Button onClick={handleMMClick}>{isInMaintenanceMode ? 'Disable Maintenance Mode' : 'Enable Maintenance Mode'}</Button>}
                tabs={[
                    { title: "Firmware", child: <ManageFirmware /> },
                    { title: "Devices", child: <GlobalDevices /> },
                    { title: "Users", child: <GlobalUsers /> },
                    { title: "Organizations", child: <OrganizationAdmin /> },
                    { title: "CHIRP Library", child: <ChirpLibrary /> },
                    { title: "Tracker Library", child: <TrackerLibrary /> },
                    { title: "Jobs", child: <Jobs /> },
                    { title: "Cache", child: <ServerCache /> },
                    { title: "Photos", child: <PhotoLibrary /> },
                    { title: "Ground Truthing", child: <GroundTruthing /> },
                    { title: "Audit Logs", child: <AuditLogsView /> },
                    { title: "Errors", child: <ErrorsView /> },
                ]}
            />
            {dialog.renderDialog((model) => (
                <>
                    <p className="mb-5">{model?.instructions}</p>
                    <InputRow>
                        <Input label="Message" placeholder="API update complete" onChange={x => model!.message = x.currentTarget.value} />
                    </InputRow>
                </>
            ))}
        </>
    );
};
